const SESSION_KEY = "jooti_payment_session_id";

function randomPart() {
  return Math.random().toString(36).slice(2, 12);
}

function sessionId() {
  if (typeof window === "undefined") return `payment_${Date.now()}_${randomPart()}`;

  try {
    const current = window.localStorage.getItem(SESSION_KEY);
    if (current) return current;

    const next = `payment_${Date.now()}_${randomPart()}`;
    window.localStorage.setItem(SESSION_KEY, next);
    return next;
  } catch {
    return `payment_${Date.now()}_${randomPart()}`;
  }
}

function browserInfo() {
  if (typeof navigator === "undefined") {
    return {};
  }

  return {
    user_agent: navigator.userAgent || "",
    platform: navigator.platform || "",
    vendor: navigator.vendor || "",
    language: navigator.language || "",
    online: typeof navigator.onLine === "boolean" ? navigator.onLine : null,
    visibility_state: typeof document !== "undefined" ? document.visibilityState : "",
    url: typeof window !== "undefined" ? window.location.href : "",
    referrer: typeof document !== "undefined" ? document.referrer : ""
  };
}

export function trackPaymentTelemetry(eventType, metadata = {}, options = {}) {
  if (typeof window === "undefined") return;

  const payload = {
    session_id: sessionId(),
    event_type: eventType,
    url: window.location.href,
    page_title: document.title || "",
    referrer: document.referrer || "",
    metadata: {
      ...metadata,
      browser: metadata.browser || browserInfo()
    }
  };

  const body = JSON.stringify(payload);

  if (options.beacon && navigator.sendBeacon) {
    try {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon("/api/analytics/events", blob);
      return;
    } catch {
      return;
    }
  }

  fetch("/api/analytics/events", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body,
    keepalive: true
  }).catch(() => {});
}

export function goToTrackedPaymentUrl(url, metadata = {}) {
  if (!url || typeof window === "undefined") return;

  let fired = false;

  const fireLeaving = () => {
    if (fired) return;
    fired = true;

    trackPaymentTelemetry("payment_external_navigation_started", {
      ...metadata,
      trigger: metadata.trigger || "redirect"
    }, { beacon: true });

    window.removeEventListener("pagehide", fireLeaving);
    document.removeEventListener("visibilitychange", handleVisibility);
  };

  const handleVisibility = () => {
    if (document.visibilityState === "hidden") {
      fireLeaving();
    }
  };

  trackPaymentTelemetry("payment_redirect_attempted", metadata, { beacon: true });

  window.addEventListener("pagehide", fireLeaving, { once: true });
  document.addEventListener("visibilitychange", handleVisibility);

  window.setTimeout(() => {
    if (!fired && document.visibilityState !== "hidden") {
      trackPaymentTelemetry("payment_redirect_still_visible", metadata, { beacon: true });
    }
  }, 4000);

  window.setTimeout(() => {
    try {
      window.location.assign(url);
    } catch {
      window.location.href = url;
    }
  }, 60);
}
